module.exports = __webpack_public_path__ + "assets/img/login-content.87e028c5.png";